/* Fable & Mirth — premium theme behaviour (no dependencies, deferred) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const desktop = window.matchMedia('(min-width: 990px)');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Mega menu (hover intent + click + keyboard) ---------- */
  function initMega(root = document) {
    $$('[data-fm-mega]', root).forEach((item) => {
      if (item.dataset.fmReady) return;
      item.dataset.fmReady = '1';
      const btn = item.querySelector('.fm-nav__link');
      let timer;
      const open = () => {
        $$('[data-fm-mega].is-open').forEach((o) => o !== item && close(o));
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      };
      const close = (el = item) => {
        el.classList.remove('is-open');
        el.querySelector('.fm-nav__link')?.setAttribute('aria-expanded', 'false');
      };
      item.addEventListener('mouseenter', () => { if (!desktop.matches) return; clearTimeout(timer); timer = setTimeout(open, 90); });
      item.addEventListener('mouseleave', () => { clearTimeout(timer); timer = setTimeout(() => close(), 160); });
      btn.addEventListener('click', () => (item.classList.contains('is-open') ? close() : open()));
      item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); btn.focus(); } });
      item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(); });
    });
  }

  /* ---------- Compact header on scroll ---------- */
  function initCompact() {
    const header = $('[data-fm-header]');
    const bar = $('[data-fm-compact]');
    if (!header || !bar) return;
    const io = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      $$('a, button', bar).forEach((el) => (el.tabIndex = show ? 0 : -1));
      if (!show) $$('[data-fm-mega].is-open', bar).forEach((o) => o.classList.remove('is-open'));
    }, { rootMargin: '0px 0px 0px 0px', threshold: 0 });
    io.observe(header);
  }

  /* ---------- Drawer + search overlay ---------- */
  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }
  function initDrawer() {
    const drawer = $('[data-fm-drawer]');
    if (!drawer) return;
    let opener;
    const open = (e) => {
      opener = e?.currentTarget;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      $$('[data-fm-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
      lock(true);
      setTimeout(() => drawer.querySelector('[data-fm-drawer-close]:not(.fm-drawer__scrim)')?.focus(), 50);
    };
    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      $$('[data-fm-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      lock(false);
      opener?.focus();
    };
    $$('[data-fm-drawer-open]').forEach((b) => b.addEventListener('click', open));
    $$('[data-fm-drawer-close]', drawer).forEach((b) => b.addEventListener('click', close));
    drawer.addEventListener('keydown', (e) => e.key === 'Escape' && close());
    desktop.addEventListener('change', (m) => m.matches && drawer.classList.contains('is-open') && close());
  }
  function initSearch() {
    const panel = $('[data-fm-search]');
    if (!panel) return;
    let opener;
    const input = panel.querySelector('input[type="search"]');
    const open = (e) => {
      opener = e?.currentTarget;
      panel.classList.add('is-open');
      lock(true);
      setTimeout(() => input?.focus(), 30);
    };
    const close = () => { panel.classList.remove('is-open'); lock(false); opener?.focus(); };
    $$('[data-fm-search-open]').forEach((b) => b.addEventListener('click', open));
    $$('[data-fm-search-close]', panel).forEach((b) => b.addEventListener('click', close));
    panel.addEventListener('keydown', (e) => e.key === 'Escape' && close());
  }

  /* ---------- Rails (arrows) ---------- */
  function initRails(root = document) {
    $$('.fm-section, .fm-products, .fm-tiles, .fm-stories', root).forEach((sec) => {
      const prev = sec.querySelector('[data-fm-prev]');
      const next = sec.querySelector('[data-fm-next]');
      if (!prev || !next || sec.dataset.fmRails) return;
      sec.dataset.fmRails = '1';
      const rail = () => $$('[data-fm-rail]', sec).find((r) => r.offsetParent !== null);
      const update = () => {
        const r = rail();
        if (!r) return;
        prev.disabled = r.scrollLeft <= 4;
        next.disabled = r.scrollLeft + r.clientWidth >= r.scrollWidth - 4;
      };
      const step = (dir) => {
        const r = rail();
        if (!r) return;
        r.scrollBy({ left: dir * r.clientWidth * 0.85, behavior: reduce.matches ? 'auto' : 'smooth' });
      };
      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      $$('[data-fm-rail]', sec).forEach((r) => r.addEventListener('scroll', update, { passive: true }));
      window.addEventListener('resize', update);
      sec.addEventListener('fm:tab', update);
      update();
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs(root = document) {
    $$('[data-fm-tabs]', root).forEach((list) => {
      const tabs = $$('[role="tab"]', list);
      const select = (tab) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        list.closest('section')?.dispatchEvent(new CustomEvent('fm:tab'));
      };
      tabs.forEach((t, i) => {
        t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', (e) => {
          const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          const n = tabs[(i + d + tabs.length) % tabs.length];
          n.focus();
          select(n);
        });
      });
    });
  }

  /* ---------- Hero slideshow ---------- */
  function initSlides(root = document) {
    $$('[data-fm-slides]', root).forEach((wrap) => {
      const slides = $$('.fm-hero__slide', wrap);
      if (slides.length < 2) return;
      const dots = $$('[data-fm-dot]', wrap.parentElement);
      let i = 0;
      let t;
      const go = (n) => {
        slides[i].classList.remove('is-active');
        slides[i].setAttribute('aria-hidden', 'true');
        dots[i]?.setAttribute('aria-current', 'false');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        slides[i].removeAttribute('aria-hidden');
        dots[i]?.setAttribute('aria-current', 'true');
      };
      const play = () => { if (reduce.matches) return; clearInterval(t); t = setInterval(() => go(i + 1), Number(wrap.dataset.interval) || 7000); };
      dots.forEach((d) => d.addEventListener('click', () => { go(Number(d.dataset.fmDot)); play(); }));
      wrap.addEventListener('mouseenter', () => clearInterval(t));
      wrap.addEventListener('mouseleave', play);
      play();
    });
  }

  /* ---------- Footer accordions (only collapsible on mobile) ---------- */
  function initFooter() {
    const cols = $$('[data-fm-footer-col]');
    const sync = () => cols.forEach((c) => (c.open = desktop.matches || window.innerWidth >= 750));
    cols.forEach((c) => c.querySelector('summary').addEventListener('click', (e) => { if (window.innerWidth >= 750) e.preventDefault(); }));
    sync();
    window.addEventListener('resize', () => { if (window.innerWidth >= 750) sync(); });
    if (window.innerWidth < 750) cols.forEach((c) => (c.open = false));
  }

  /* ---------- Cart: mirror bubble + quick add ---------- */
  function initCart() {
    const main = document.getElementById('cart-icon-bubble');
    const mirrors = $$('[data-fm-cart-mirror]');
    if (main && mirrors.length) {
      const copy = () => mirrors.forEach((m) => (m.innerHTML = main.innerHTML));
      new MutationObserver(copy).observe(main, { childList: true, subtree: true, characterData: true });
    }
    mirrors.forEach((m) => m.addEventListener('click', (e) => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { e.preventDefault(); drawer.open(m); }
    }));

    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-fm-quick-add]');
      if (!form) return;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (!cart || !window.routes) return; // fall back to normal form post
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const label = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';
      const body = new FormData(form);
      body.append('sections', cart.getSectionsToRender().map((s) => s.id));
      body.append('sections_url', window.location.pathname);
      cart.setActiveElement?.(document.activeElement);
      try {
        const res = await fetch(window.routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body });
        const data = await res.json();
        if (data.status) { btn.textContent = data.description || 'Unavailable'; setTimeout(() => (btn.textContent = label), 2400); return; }
        cart.classList.contains('is-empty') && cart.classList.remove('is-empty');
        cart.renderContents(data);
        btn.textContent = label;
      } catch (err) {
        form.submit();
      } finally {
        btn.disabled = false;
      }
    });
  }

  /* ---------- Gentle reveal for below-the-fold blocks ---------- */
  function initReveal() {
    if (reduce.matches || !('IntersectionObserver' in window) || window.Shopify?.designMode || document.documentElement.classList.contains('fm-motion')) return;
    const els = $$('.fm-section-head, .fm-card, .fm-tile, .fm-story, .fm-feature__grid, .fm-press__item, .fm-visit__grid, .fm-band__grid');
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (!en.isIntersecting) return;
      en.target.classList.add('fm-reveal-in');
      en.target.classList.remove('fm-reveal-pending');
      io.unobserve(en.target);
    }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => {
      if (el.getBoundingClientRect().top > window.innerHeight) {
        el.classList.add('fm-reveal-pending');
        io.observe(el);
      }
    });
    setTimeout(() => $$('.fm-reveal-pending').forEach((el) => el.classList.replace('fm-reveal-pending', 'fm-reveal-in')), 6000);
  }

  function init(root) {
    initMega(root); initRails(root); initTabs(root); initSlides(root);
  }
  const boot = () => { init(document); initCompact(); initDrawer(); initSearch(); initFooter(); initCart(); initReveal(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

/* ---------- Sticky add-to-cart bar on phones (product pages) ---------- */
(() => {
  const start = () => {
    const info = document.querySelector('product-info');
    const form = info && info.querySelector('product-form form, form[data-type="add-to-cart-form"]');
    const btn = form && form.querySelector('[name="add"]');
    if (!btn || document.querySelector('.fm-sticky-atc')) return;
    const titleEl = info.querySelector('.product__title h1') || info.querySelector('.product__title h2') || info.querySelector('h1');
    const title = titleEl ? titleEl.textContent : document.title;
    const img = info.querySelector('.product__media img');
    const bar = document.createElement('div');
    bar.className = 'fm-sticky-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');
    bar.innerHTML = (img ? '<img class="fm-sticky-atc__img" alt="" loading="lazy">' : '') + '<div class="fm-sticky-atc__t"><span></span><b></b></div><button type="button" class="fm-btn"></button>';
    if (img) bar.querySelector('img').src = img.currentSrc || img.src;
    bar.querySelector('span').textContent = title.trim();
    const own = bar.querySelector('button');
    const sync = () => {
      const label = (btn.querySelector('span') || btn).textContent.trim();
      own.textContent = label;
      own.disabled = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
      const p = info.querySelector('.price .price-item--last, .price .price-item--regular');
      bar.querySelector('b').textContent = p ? p.textContent.trim() : '';
    };
    sync();
    new MutationObserver(sync).observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    own.addEventListener('click', () => btn.click());
    document.body.appendChild(bar);
    document.body.classList.add('fm-has-sticky-atc');
    const footer = document.querySelector('.fm-footer');
    let btnVisible = false, footVisible = false;
    const update = () => bar.classList.toggle('is-on', !btnVisible && !footVisible);
    new IntersectionObserver(([e]) => { btnVisible = e.isIntersecting; update(); }).observe(btn);
    if (footer) new IntersectionObserver(([e]) => { footVisible = e.isIntersecting; update(); }).observe(footer);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
